import { render, staticRenderFns } from "./SalasEspera.vue?vue&type=template&id=1c9aaf1c&scoped=true"
import script from "./SalasEspera.vue?vue&type=script&lang=js"
export * from "./SalasEspera.vue?vue&type=script&lang=js"
import style0 from "./SalasEspera.vue?vue&type=style&index=0&id=1c9aaf1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9aaf1c",
  null
  
)

export default component.exports